import { doc, getDoc } from "firebase/firestore"
import { userpermissions } from "../firebase"

export async function isAdmin(user) {
  const userId = user.uid
  const userPermissionsRef = doc(userpermissions, userId)
  const userPermissions = (await getDoc(userPermissionsRef)).data()
  return userPermissions.isAdmin
}
